import React from 'react';

function Title(props) {
    return (<h5 className={props.class}>{props.title}</h5>)
}
export default Title;
